import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from "@angular/platform-browser";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule, Routes } from "@angular/router";
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { AppConfigService } from 'api/app-config-service.service';
import { FuseModule } from "@fuse/fuse.module";
import { FuseSharedModule } from "@fuse/shared.module";
import {
    FuseConfirmDialogModule,
    FuseProgressBarModule,
    FuseSidebarModule,
    FuseThemeOptionsModule,
} from "@fuse/components";

import { fuseConfig } from "app/fuse-config";

import { AppComponent } from "app/app.component";
import { LayoutModule } from "app/layout/layout.module";
import { ProfileModule } from "./main/profile/profile.module";
import { ScheduleModule } from "./main/schedule/schedule.module";
import { LoginModule } from "./main/login/login.module";
import { LogoutModule } from "./main/logout/logout.module";
import { ApiGatewayModule } from "api/api-gateway-module";
import { NgxMaskModule } from "ngx-mask";
import { ExamsModule } from "./main/exams/exams.module";
import { UnregisteredScheduleModule } from "./main/unregistered-schedule/unregistered-schedule.module";
import { ScheduleSummaryModule } from "./main/schedule-summary/schedule-summary.module";

import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { CheckinModule } from "./main/checkin/checkin.module";
import { UnregisteredNewModule } from "app/main/unregistered-new/unregistered-new.module";
import { AuthInterceptorService } from './services/auth-interceptor.service';
import { HomeModule } from './main/home/home.module';

registerLocaleData(localePt);

const appRoutes: Routes = [
    {
        path: "**",
        redirectTo: "auth/login",
    },
];


@NgModule({
    declarations: [AppComponent],
    imports: [
        ApiGatewayModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        RouterModule.forRoot(appRoutes),

        TranslateModule.forRoot(),

        // Material moment date module
        MatMomentDateModule,

        // Material
        MatButtonModule,
        MatIconModule,

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,
        FuseConfirmDialogModule,

        // App modules
        LayoutModule,
        ProfileModule,
        ScheduleModule,
        LoginModule,
        LogoutModule,
        ExamsModule,
        UnregisteredScheduleModule,
        UnregisteredNewModule,
        ScheduleSummaryModule,
        CheckinModule,
        HomeModule,

        // core
        NgxMaskModule.forRoot(),
    ],
    bootstrap: [AppComponent],
    providers: [{ provide: LOCALE_ID, useValue: "pt-BR" },

    
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true }
    ],
})
export class AppModule {}
